import React, { useContext } from 'react';
import manager from '../Manager';
import { AppContext } from '../AppContext';
import { toast } from 'react-toastify';
import Utils from '../CourseApp/Helper/utils';
import {
    IconMultipleChoiceAnswerCorrect,
    IconMultipleChoiceAnswerWrong
} from '../icons/svgs';

function NextAction({ icon, label }) {
    const { globalState, updateGlobalState } = useContext(AppContext);
    const { selectedIndex, slides, values } = globalState;
    const toastId = React.useRef(null);
    let selectedIndexLabel = selectedIndex + 1;

    const toastAnswer = () => {
        return new Promise((resolve) => {
            let slideDataAnswer = slides[selectedIndex].data?.answer;
            let correctAnswer = slideDataAnswer.filter(
                (item) => item.correct === 'true'
            );
            let isAnswerCorrect = false;
            let correctAnswerText = correctAnswer[0].text;
            let userAnswer = values[selectedIndex].answer;
            if (
                typeof values[selectedIndex] !== 'undefined' &&
                userAnswer === correctAnswerText
            ) {
                isAnswerCorrect = true;
            }

            let toastMessage = isAnswerCorrect ? (
                <div className="choice-option-confirm">
                    <div className="choice-option-confirm-icon">
                        <IconMultipleChoiceAnswerCorrect />
                    </div>
                    <div className="choice-option-confirm-message">
                        <h3>Correcto!</h3>
                        <p>Amazing learner we have here</p>
                    </div>
                </div>
            ) : (
                <div className="choice-option-confirm">
                    <div className="choice-option-confirm-icon">
                        <IconMultipleChoiceAnswerWrong />
                    </div>
                    <div className="choice-option-confirm-message">
                        <h3>Oops You Wrong...</h3>
                        <p>The correct answer is:</p>
                        <b>{correctAnswerText}</b>
                    </div>
                </div>
            );

            let toastOptions = {
                position: 'bottom-center',
                autoClose: false,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: 'light'
            };
            toastId.current = toast(toastMessage, toastOptions);

            const unsubscribe = toast.onChange((payload) => {
                if (payload.status === 'removed') {
                    unsubscribe();
                    resolve();
                }
            });
        });
    };

    const handleNext = async () => {
        if (!manager.inEditor) {
            if (selectedIndexLabel >= slides.length) {
                handleFinish();
                return false;
            }
            let isBeforeNext = true;
            if (manager.options.onBeforeNextCallback) {
                isBeforeNext = await manager.runAsPromise(
                    manager.options.onBeforeNextCallback,
                    selectedIndex,
                    slides[selectedIndex]
                );
                if (
                    slides[selectedIndex].template?.type() ===
                    'MultipleChoiceTemplate'
                ) {
                    if (typeof values[selectedIndex] === 'undefined') {
                        Utils.showError('Please select your answer');
                        return false;
                    }
                    await toastAnswer();
                }
            }

            if (isBeforeNext) {
                updateGlobalState('selectedIndex', selectedIndex + 1);
                // get response from result data, if any slidesDataProgress, update manager.
                if (typeof isBeforeNext?.slidesDataProgress !== 'undefined') {
                    updateGlobalState('progressData', {"slidesProgressData": isBeforeNext.slidesDataProgress });
                }

                if (manager.options.onNextCallback) {
                    await manager.runAsPromise(
                        manager.options.onNextCallback,
                        selectedIndex + 1,
                        values
                    );
                }
            }
        }
    };

    const handleFinish = async () => {
        await manager.runAsPromise(
            manager.options.onSaveCallback,
            slides,
            values
        );
        await manager.runAsPromise(manager.options.onFinishCallback, values);
    };
    return (
        <div className="tbcourse-template-actions">
            <div className="d-grid">
                <button
                    type="button"
                    className="btn btn-primary btn-block"
                    onClick={handleNext}
                >
                    <span className="center-vertical">
                        {label} {icon}
                    </span>
                </button>
            </div>
        </div>
    );
}

export default NextAction;
